import React from "react";
import "./PageLifelongLearning.css";

export default class PageLifelongLearning extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
		};
	}

	// eslint-disable-next-line class-methods-use-this
	render() {
		return (
			<div id={"PageLifelongLearning"}>
			</div>
		);
	}
}
